import Axios from "axios";

class DataService {
  //Grammar
  createNonRecursiveInitial(dados, cred) {
    return Axios.post(`/grammar/nonRecursiveInitial`, dados, cred);
  }

  createNonContracting(dados, cred) {
    return Axios.post(`/grammar/nonContracting`, dados, cred);
  }

  createNonCascade(dados, cred) {
    return Axios.post(`/grammar/nonCascade`, dados, cred);
  }

  createOnlyTerm(dados, cred) {
    return Axios.post(`/grammar/onlyTerm`, dados, cred);
  }

  createOnlyReach(dados, cred) {
    return Axios.post(`/grammar/onlyReach`, dados, cred);
  }

  createGrId(dados, cred) {
    return Axios.post(`/grammar/grammaId`, dados, cred);
  }

  createRemovingTheImmediateLeftRecursion(dados, cred) {
    return Axios.post(`/grammar/immedLeftRecursion`, dados, cred);
  }

  createRemovalDirLeftRec(dados, cred) {
    return Axios.post(`/grammar/removalDirLeftRec`, dados, cred);
  }

  createChomsky(dados, cred) {
    return Axios.post(`/grammar/chomSkyandgreibach`, dados, cred);
  }

  createCYK(dados, cred) {
    return Axios.post(`/grammar/cyk`, dados, cred);
  }

  createLeftMostDerivation(dados, cred) {
    return Axios.post(`/grammar/leftMostDerivation`, dados, cred);
  }

  createCheckAmbiguity(dados, cred) {
    return Axios.post(`/grammar/checkAmbiguity`, dados, cred);
  }

  CfgToPda(dados, cred) {
    return Axios.post(`/grammar/cfgToPda`, dados, cred);
  }

  createHTML(dados, cred) {
    return Axios.post(`/grammar/HTML`, dados, cred);
  }

  getGramatica(cred) {
    return Axios.get(`/grammar`, cred);
  }

  getGramaticaHTML(cred) {
    return Axios.get(`/grammar/html`, cred);
  }

  //AUTOMATON
  createGraph(dados, cred) {
    return Axios.post(`/automaton/HTML`, dados, cred);
  }

  getAutomatonByDOT(dados, cred) {
    return Axios.post(`/fsa/dotToAutomaton`, dados, cred);
  }
  seeIfCompleteAutomaton(dados, cred) {
    return Axios.post(`/fsa/seeIfComplete`, dados, cred);
  }

  createCompleteAutomaton(dados, cred) {
    return Axios.post(`/fsa/createComplete`, dados, cred);
  }

  seeIfAFDAutomaton(dados, cred) {
    return Axios.post(`/fsa/seeIfAFD`, dados, cred);
  }
  seeIfAFNDLambdaAutomaton(dados, cred) {
    return Axios.post(`/fsa/seeIfAFNDLambda`, dados, cred);
  }

  convertAFNDtoAFD(dados, cred) {
    return Axios.post(`/fsa/AFNDtoAFD`, dados, cred);
  }

  convertAFNDLambdaToAFND(dados, cred) {
    return Axios.post(`/fsa/AFNDLambdatoAFD`, dados, cred);
  }

  testInputString(dados, cred) {
    return Axios.post(`/fsa/testInputString`, dados, cred);
  }

  getTransitionTableAFNDLambda(dados, cred) {
    return Axios.post(`/fsa/tableAFNDLambda`, dados, cred);
  }

  getTransitionTableAFND(dados, cred) {
    return Axios.post(`/fsa/tableAFND`, dados, cred);
  }

  getTransitionTableAFD(dados, cred) {
    return Axios.post(`/fsa/tableAFD`, dados, cred);
  }

  getMinimazeAutomaton(dados, cred) {
    return Axios.post(`/fsa/afdMinization`, dados, cred);
  }
  getTableMinimization(dados, cred) {
    return Axios.post(`/fsa/afdTableMinization`, dados, cred);
  }
  getAutomatonByRegex(dados, cred) {
    const form = new FormData();
    form.append("regex", dados);
    return Axios.post(`/fsa/getAutomatonByRegex`, form, cred);
  }
  checkWord(dados, word, cred) {
    return Axios.post(`/fsa/checkWord/${word}`, dados, cred);
  }
  getGridPositions(dados, cred) {
    return Axios.post(`/fsa/gridPositions`, dados, cred);
  }

  //USER
  signUp(user) {
    return Axios.post(`/signUp`, user);
  }

  login(dataLogin) {
    return Axios.post(`/auth/signin`, dataLogin);
  }

  logoutToken(cred) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: cred.headers.Authorization,
      },
    };

    return Axios.post(`/token`, cred.headers.Authorization.split("·"), config);
  }

  logout() {
    return Axios.get(`/logout`);
  }

  getUserByEmail(email, cred) {
    return Axios.get(`/user/${email}`, cred);
  }

  postSaveHistoricalGr(email, historicalGrammar, cred) {
    return Axios.post(`/${email}/user/grammar`, historicalGrammar, cred);
  }

  postSaveHistoricalMc(email, historicalMachine, cred) {
    return Axios.post(`/${email}/user/machine`, historicalMachine, cred);
  }

  updateHistoricalMc(email, historicalMachine, createdDate, cred) {
    return Axios.put(
      `/${email}/user/machine/${encodeURIComponent(createdDate)}`,
      historicalMachine,
      cred
    );
  }

  updateHistoricalGr(email, historicalGrammar, createdDate, cred) {
    return Axios.put(
      `/${email}/user/grammar/${encodeURIComponent(createdDate)}`,
      historicalGrammar,
      cred
    );
  }

  updateUser(user, cred) {
    const data = {
      email: user.email,
      name: user.name,
      firstname: user.firstname,
      lastname: user.lastname,
      password: user.autho,
      username: user.email,
      id: user.id,
      autho: user.autho,
    };
    return Axios.put(`/user`, data, cred);
  }

  updateShowInfo(user, cred) {
    return Axios.put(`/user/teste`, user, cred);
  }

  deleteUser(email, cred) {
    return Axios.delete(`/user/${email}`, cred);
  }

  sendEmail(dados, cred) {
    return Axios.post(`/error/sendError`, dados, cred);
  }

  reports(cred) {
    return Axios.get(`/reports`, cred);
  }

  limitedReports(cred, lastUsers) {
    console.log(lastUsers);
    return Axios.get(`/last/reports/${lastUsers}`, cred);
  }
  forgotPass(email) {
    const data = {
      mail: email,
    };
    return Axios.post(`/auth/forgotPass`, data);
  }

  changePass(email, lastPassword, newPassword, cred) {
    const form = new FormData();
    form.append("oldPassword", lastPassword);
    form.append("newPassword", newPassword);

    return Axios.post(`/user/changePass/${email}`, form, cred);
  }

  postLastAccess(email, date, cred) {
    const form = new FormData();
    form.append("lastAccess", date);
    return Axios.post(`/user/lastAccess/${email}`, form, cred);
  }

  //SYSTEM
  isAlive(cred) {
    return Axios.get(`/isAlive`, cred);
  }
  //arrumar
  changeStatusSystem(cred) {
    return Axios.get(`/changeStatusSystem`, cred);
  }
}

export default new DataService();
